<template>
    <div>
        <img
            src="../../assets/newImg/setting_logo.png"
            class="setting-logo"
            alt=""
        />
        <!-- <div class="edition">鲍氏商城 1.0.0</div> -->
        <div style="height:19px"></div>
        <div
            class="setting-list"
            @click="$router.push({ path: '/change_password' })"
        >
            <div class="setting-li">
                <img
                    src="../../assets/newImg/setting_reset.png"
                    class="icon-left"
                    alt=""
                />
                <div class="setting-txt">重置密码</div>
            </div>
            <img
                src="../../assets/newImg/icon_right.png"
                class="icon-right"
                alt=""
            />
        </div>
        <div class="setting-list" @click="mine1">
            <div class="setting-li">
                <img
                    src="../../assets/newImg/yhxy.png"
                    class="icon-left"
                    alt=""
                />
                <div class="setting-txt">用户协议</div>
            </div>
            <img
                src="../../assets/newImg/icon_right.png"
                class="icon-right"
                alt=""
            />
        </div>

        <div class="setting-list" @click="mine2">
            <div class="setting-li">
                <img
                    src="../../assets/newImg/yszc.png"
                    class="icon-left"
                    alt=""
                />
                <div class="setting-txt">隐私政策</div>
            </div>
            <img
                src="../../assets/newImg/icon_right.png"
                class="icon-right"
                alt=""
            />
        </div>

        <div class="setting-list" @click="aboutUs">
            <div class="setting-li">
                <img
                    src="../../assets/newImg/setting_us.png"
                    class="icon-left"
                    alt=""
                />
                <div class="setting-txt">关于我们</div>
            </div>
            <img
                src="../../assets/newImg/icon_right.png"
                class="icon-right"
                alt=""
            />
        </div>
        <div class="setting-list" @click="downLoad">
            <div class="setting-li">
                <img
                    src="../../assets/newImg/down_load.png"
                    class="icon-left"
                    alt=""
                />
                <div class="setting-txt">下载App</div>
            </div>
            <img
                src="../../assets/newImg/icon_right.png"
                class="icon-right"
                alt=""
            />
        </div>
        <div class="setting-list" @click="backLogin">
            <div class="setting-li">
                <img
                    src="../../assets/newImg/warn.png"
                    class="icon-left"
                    alt=""
                />
                <div class="setting-txt">退出登录</div>
            </div>
            <img
                src="../../assets/newImg/icon_right.png"
                class="icon-right"
                alt=""
            />
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import { Dialog } from "vant";
Vue.use(Dialog);
export default {
    name: "setting",
    data() {
        return {};
    },
    methods: {
        aboutUs() {
            // window.location.href=global.ABOUT_US
            this.$router.push("/news_detail/100000");
        },
        mine1() {
            window.location.href =
                "http://app.shangpinbaoshi.com/register/info?type!=1";
        },
        mine2() {
            window.location.href =
                "http://app.shangpinbaoshi.com/register/info?type=1";
        },
        downLoad() {
            window.location.href = "https://appstore.3todo.cn/baoshi/";
        },
        backLogin() {
            Dialog.confirm({
                title: "温馨提示",
                message: "您确定要退出登录吗？",
            })
                .then(() => {
                    // on confirm
                    localStorage.clear();
                    this.$router.replace("/login");
                })
                .catch(() => {
                    // on cancel
                });
        },
    },
};
</script>
<style scoped>
.back {
}
.setting-logo {
    width: 103px;
    height: 96px;
    margin: 27px auto 9px auto;
    display: flex;
    align-items: center;
    justify-content: center;
}
.edition {
    text-align: center;
    color: #333333;
    font-size: 16px;
}
.setting-list {
    margin: 0 11px 5px 11px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 44px;
    background: #ffffff;
    border-radius: 10px;
}
.setting-list .setting-li {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.setting-list .setting-li .icon-left {
    width: 13px;
    height: 15px;
    margin: auto 11px auto 15px;
}
.setting-list .setting-li .setting-txt {
    font-size: 15px;
    color: #333333;
}
.setting-list .icon-right {
    width: 40px;
    height: 50px;
    margin-right: 10px;
}
</style>
